import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';
import { InfoTitle } from './propertycard';

export const DigitalPage = () => {
  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage-digital'>
          {/* <img src={process.env.PUBLIC_URL + '/images/intro-bg.jpg'} alt="headImage" style={{ width: '100%', position:'relative' }} />   */}
          <img src={process.env.PUBLIC_URL + '/images/pexels-startup-stock-photos-7375.jpg'} alt="headImage" style={{ width: '100%', position:'relative' }} />  
          <h1>DIGITALIZATION</h1>
        </div>


        <div className='digital-content'>

          <div className='digital-content-2-outer'>
            <div className='digital-content-2'>
              <div className='digital-text'>
                  <h2 style={{ color:'#ffba03'}}>Smart Solutions For Facilities Management</h2>
                  <h3>
                    ‣ Smartphone and mobile device applications
                  <br />
                    ‣ Seamless cloud based technology
                  </h3>   
              </div>
              <div className='digital-image'>
                  <InfoTitle
                      className="info-value"
                      value={process.env.PUBLIC_URL + '/images/smartsol.jpg'}
                  />
              </div>
            </div>

            <div className='digital-content-2'>
                <div className='digital-text'>
                    <h2 style={{ color:'#ffba03'}}>Digitalized Data</h2>
                    <h3>
                      ‣ 3D Modelling integrated with live building data
                    <br />
                      ‣ Virtual site visit features
                    </h3>   
                </div>
                <div className='digital-image'>
                    <InfoTitle
                        className="info-value"
                        value={process.env.PUBLIC_URL + '/images/digital.jpg'}
                    />
                </div>
            </div>
          </div>
          
          <div className='digital-content-2-outer'>
            <div className='digital-content-2'>
              <div className='digital-text'>
                  <h2 style={{ color:'#ffba03'}}>Dynamic Management Dashboards</h2>
                  <h3>
                    ‣ Real-time reporting
                  <br />
                    ‣ Data analysis and probability simulation
                  </h3>   
              </div>
              <div className='digital-image'>
                  <InfoTitle
                      className="info-value"
                      value={process.env.PUBLIC_URL + '/images/REPORT.jpg'}
                  />
              </div>
          </div>

          <div className='digital-content-2'>
              <div className='digital-text'>
                  <h2 style={{ color:'#ffba03'}}>Smart Network Integration</h2>
                  <h3>
                    ‣ Fully Customizable Asset Management System (AMS)
                  </h3>   
              </div>
              <div className='digital-image'>
                  <InfoTitle
                      className="info-value"
                      value={process.env.PUBLIC_URL + '/images/CMIS.jpg'}
                  />
              </div>
          </div>
          </div>
          

        </div>

        <div className='footer'>
          <FooterStyle />
        </div>

      </div>
    </div>
  );
}

export default DigitalPage;
